import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    this.boundHandleClick = this.handleClick.bind(this);
    this.element.addEventListener("click", this.boundHandleClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundHandleClick);
  }

  handleClick(event) {
    // Don't navigate if clicking on interactive elements (links, buttons, inputs)
    const interactiveElements = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"];
    let target = event.target;

    // Check if the click target or any of its parents is an interactive element
    while (target && target !== this.element) {
      if (interactiveElements.includes(target.tagName)) {
        return;
      }
      target = target.parentElement;
    }

    // Navigate to the URL using Turbo for smooth transition
    if (this.urlValue) {
      Turbo.visit(this.urlValue);
    }
  }
}
